__turbopack_context__.v({
  "highlight": "highlightsList-module-scss-module__P4lxUG__highlight",
  "highlight_title": "highlightsList-module-scss-module__P4lxUG__highlight_title",
  "image": "highlightsList-module-scss-module__P4lxUG__image",
  "image_wrapper": "highlightsList-module-scss-module__P4lxUG__image_wrapper",
  "main": "highlightsList-module-scss-module__P4lxUG__main",
  "noResults": "highlightsList-module-scss-module__P4lxUG__noResults",
  "wrapper": "highlightsList-module-scss-module__P4lxUG__wrapper",
});
